import DataLayerService from "../../DataLayerService.js";
import DlPurchase from "../../components/dl-purchase.js";
import { collectComponentAttributes } from "../common/component-attributes.js";

/**
 * Handler für das Sammeln und Pushen von purchase Events
 *
 * Sammelt beim window.load Event alle dl-purchase Elemente auf der Seite,
 * kombiniert deren Daten und pusht ein einziges purchase Event.
 */
export default class PurchaseHandler {
    #datalayerService;
    #initialized = false;

    /**
     * Erstellt einen neuen PurchaseHandler
     * @param {DataLayerService} datalayerService - DataLayerService Instanz
     */
    constructor(datalayerService = new DataLayerService()) {
        this.#datalayerService = datalayerService;
    }

    /**
     * Initialisiert den Handler und registriert den window.load Event Listener
     */
    init() {
        if (this.#initialized) {
            console.warn('[PurchaseHandler] Already initialized');
            return;
        }

        this.#initialized = true;

        // Warte auf window.load Event
        if (document.readyState === 'complete') {
            // Seite ist bereits geladen - verwende setTimeout damit alle
            // dl-purchase Elemente erst vollständig erstellt werden
            setTimeout(() => {
                this.#collectAndPushPurchase();
            }, 0);
        } else {
            // Registriere Event Listener für load Event
            window.addEventListener('load', () => {
                this.#collectAndPushPurchase();
            });
        }
    }

    /**
     * Sammelt alle dl-purchase Elemente und pusht ein kombiniertes purchase Event
     * @private
     */
    #collectAndPushPurchase() {
        const elements = document.querySelectorAll(DlPurchase.tag);

        if (elements.length === 0) {
            return;
        }

        // Sammle alle Parameter von allen Elementen
        const combinedParams = {};
        const allItems = [];

        elements.forEach(element => {
            if (element instanceof DlPurchase) {
                const params = element.params;
                const items = element.items;

                // Merge params - spätere Elemente überschreiben frühere bei Konflikten
                Object.assign(combinedParams, params);

                // Sammle alle items
                if (items.length > 0) {
                    allItems.push(...items);
                }
            }
        });

        // Sammle zusätzliche Attribute vom component-Element (falls vorhanden)
        // Nehme das erste dl-purchase Element als Referenz
        const firstElement = elements[0];
        if (firstElement) {
            const componentAttributes = collectComponentAttributes(firstElement);
            Object.assign(combinedParams, componentAttributes);
        }

        // Pushe das kombinierte purchase Event
        try {
            this.#datalayerService.pushEvent(
                'purchase',
                combinedParams,
                allItems.length > 0 ? allItems : null
            );
        } catch (error) {
            console.error('[PurchaseHandler] Failed to push purchase event:', error);
        }
    }
}
